import { useNavigate, useParams } from "react-router-dom";
import { DashboardLayout } from "./_common/DashboardLayout";
import { useEffect, useState } from "react";
import { pingstationGetService, pingstationUpdateService } from "../utils/api";
import { PingstationForm } from "./components/PingstationForm";
import { notifyError, notifySuccess } from "../utils/notify";
import { BiRadar } from "react-icons/bi";

export function PingstationEdit() {
    const params = useParams();
    const { id } = params;

    const navigate = useNavigate();
    

    const [pingstation, setPingstation] = useState(null);

    const getPingstation = () => {
        pingstationGetService(id, (data) => {
            if (data.success) {
                setPingstation(data.pingStation)
            } else {
                notifyError(data.message)
            }
        })
    }

    useEffect(() => {
        getPingstation();
    }, [id]);

    if (!id) {
        navigate('/pingstations')
    }

    const parsedRaw = pingstation?.raw_status ? JSON.parse(pingstation.raw_status) : null;
    // {
    //     "pingStationGuid": "754104714b1006d7",
    //     "pingStationVersionMajor": 1,
    //     "pingStationVersionMinor": 0,
    //     "pingStationVersionBuild": 23,
    //     "timeStamp": "2025-01-07T02:01:04Z",
    //     "pingStationLatDD": 45.317039,
    //     "pingStationLonDD": -75.657639,
    //     "pingStationAltType": 1,
    //     "pingStationAltMM": 88500,
    //     "gpsStatus": 4,
    //     "receiverStatus": 0
    //   }
    const version = `${parsedRaw?.pingStationVersionMajor}.${parsedRaw?.pingStationVersionMinor}.${parsedRaw?.pingStationVersionBuild}`;

    if (!pingstation) {
        return <DashboardLayout route="/pingstation/edit">
            <h1 className="text-4xl font-semibold">Pingstation Edit</h1>
            <div>Loading...</div>
        </DashboardLayout>
    }
    

    return <DashboardLayout route="/pingstation/edit">
        <h1 className="text-4xl font-semibold">Pingstation Edit</h1>

        <div className="grid grid-cols-3 gap-4">
            <div className="col-span-1">
                <PingstationForm
                    initialData={pingstation}
                    onSubmit={(data) => {
                        if (pingstation.id) {
                            // Update
                            pingstationUpdateService({ id: pingstation.id, ...data }, (data) => {
                                if (data.success) {
                                    notifySuccess(data.message)
                                    getPingstation();
                                } else {
                                    notifyError(data.message)
                                }
                            });
                        }
                    }}
                />
            </div>


            <div className="col-span-1 ml-10 mt-10">
                <div className="bg-white p-8 rounded-lg shadow-md">
                    <h2 className="text-xl font-semibold mb-4">Pingstation Details</h2>
                    <div>
                        <strong>Station ID: </strong> {pingstation.pingstation_id}
                    </div>
                    <div>
                        <strong>Latitude: </strong> {pingstation.lat}
                    </div>
                    <div>
                        <strong>Longitude: </strong> {pingstation.lon}
                    </div>
                    <div>
                        <strong>Altitude: </strong> {Math.round(pingstation.altitude/1000)}m
                    </div>
                    <div>
                        <strong>Version: </strong> {version}
                    </div>
                    <div>
                        <strong>Activated At: </strong> {new Date(pingstation.activated_at).toLocaleString()}
                    </div>
                    <div>
                        <strong>Last Heard: </strong> {new Date(pingstation.last_heard).toLocaleString()}
                    </div>
                    <div>
                        <strong>VRS Link: </strong> <a className="transition duration-300 text-2xl text-cyan-500 hover:text-cyan-600 inline-block align-middle" href={`http://vrs.team-eagle.ca:8081/VirtualRadar/desktop.html?source=adew&lat=${pingstation.lat}&lng=${pingstation.lon}`} target="_blank" rel="noreferrer">
                            <BiRadar />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </DashboardLayout>
}